import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
// import { Link as RouterLink } from 'react-router';

export default function LinkBase({ children, removeSpaces = false, sx = [], ...props }) {
  const { href, variant = 'p3-link-bold', ...rest } = { ...props };
  return (
    <Link href={href} underline="always" {...rest}>
      {removeSpaces === true ? (
        <Typography sx={{ ...sx }} variant={variant}>
          {children.trim()}
        </Typography>
      ) : (
        <Typography sx={{ ...sx }} variant={variant}>
          &nbsp;{children.trim()}&nbsp;
        </Typography>
      )}
    </Link>
  );
}

// export function ComponentLink({ children, removeSpaces = false, sx = [], ...props }) {
//   const { href, variant = 'p3-link-bold', ...rest } = { ...props };
//   return (
//     <Link component={RouterLink} href={href} underline="always" {...rest}>
//       {removeSpaces === true ? (
//         <Typography sx={{ ...sx }} variant={variant}>
//           {children.trim()}
//         </Typography>
//       ) : (
//         <Typography sx={{ ...sx }} variant={variant}>
//           &nbsp;{children.trim()}&nbsp;
//         </Typography>
//       )}
//     </Link>
//   );
// }

LinkBase.propTypes = {
  /**
   * Link Children
   */
  children: PropTypes.node.isRequired,
  /**
   * Optional sx (styling) properties
   */
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

LinkBase.defaultProps = {
  children: null,
  sx: {},
};
